<app-display-card>
  <div
    class="row justify-content-between align-items-center"
    (click)="collapseGeneralLiabilities = !collapseGeneralLiabilities"
  >
    <div class="col-4">
      <h3>General Liabilities</h3>
    </div>

    <div class="col-3 text-end">
      <i
        class="bi bi-chevron-{{
          collapseGeneralLiabilities ? 'up' : 'down'
        }} fs-32 fw-semibold"
      ></i>
    </div>
  </div>

  @if (complianceSettingForms && complianceSettingForms.length > 0) {
    <div
      class="inner-panel rounded"
      [(ngbCollapse)]="collapseGeneralLiabilities"
    >
      @if (!collapseGeneralLiabilities) {
        <div class="row mx-2 d-flex align-items-start">
          <div class="col-3 px-0">
            @for (
              generalLiability of generalLiabilitiesMapArr[0]
                | keyvalue: keyValuePairDefaultOrder;
              track generalLiability
            ) {
              @if (generalLiability.value.show) {
                <div
                  class="form-group-container mb-0 d-flex flex-column justify-content-center"
                >
                  @if (generalLiability.value.inputType === 'none') {
                    <div class="spacer"></div>
                  }
                  @if (generalLiability.value.inputType !== 'none') {
                    <label class="form-label text-wrap first-column-label">{{
                      generalLiability.key
                    }}</label>
                  }
                </div>
              }
            }
          </div>
          @for (
            column of generalLiabilitiesMapArr;
            track column;
            let colIndex = $index
          ) {
            <form class="col-3 px-0">
              @for (
                entry of column | keyvalue: keyValuePairDefaultOrder;
                track entry;
                let entryIndex = $index
              ) {
                @if (entry.value.show) {
                  <div
                    class="form-group-container mb-0 px-3 d-flex flex-column justify-content-center"
                    [ngClass]="{
                      'text-center': entry.value.inputType === 'none'
                    }"
                  >
                    @if (entry.value.inputType === 'none') {
                      <label class="form-label">
                        {{ entry.key }}
                      </label>
                    }
                    @if (entry.value.inputType === 'select') {
                      <select
                        class="form-select pe-3"
                        [formControl]="entry.value.formControl"
                      >
                        @for (
                          item of entry.value.selectOptions
                            | keyvalue: keyValuePairDefaultOrder;
                          track item
                        ) {
                          <option [ngValue]="getOptionValue(item)">
                            {{ item.key }}
                          </option>
                        }
                      </select>
                    }
                    @if (entry.value.inputType === 'number') {
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter Amount"
                          [inputMask]="currencyMask"
                          (ngModelChange)="
                            applyCurrencyFormat(entry.value.formControl, $event)
                          "
                          [formControl]="entry.value.formControl"
                        />
                      </div>
                    }
                    @if (entry.value.inputType === 'checkBox') {
                      <div class="form-check-group">
                        <input
                          id="{{ entry.key + (entryIndex + colIndex) }}"
                          type="checkbox"
                          class="form-check-input"
                          (change)="onGeneralLiabilityIsRequiredChange()"
                          [formControl]="entry.value.formControl"
                        />
                        <label
                          for="{{ entry.key + (entryIndex + colIndex) }}"
                          class="form-check-label"
                          >{{
                            entry.value.checkBoxText
                              ? entry.value.checkBoxText
                              : 'Required?'
                          }}</label
                        >
                      </div>
                    }
                  </div>
                }
              }
            </form>
          }
        </div>
      }
    </div>
  }
</app-display-card>
